import React, { useState } from 'react';
import Intl from '@fx-ui/intl';
import { Drawer, Menu, Popover } from '@fx-ui/fine-design';
import { map, isEmpty, size } from '@libs/shared';
import { LoginType } from '~/interfaces';
import { IconFont } from '~/components';
import { getAllowSelectedSuites, getOtherLoginItemConfig } from '../../../../utils/login';
import { isMobileUA } from '~/utils';

interface CollapseLoginItemsProps {
    loginItems: LoginType[];
    onLoginItemClick: (
        item: LoginType,
        onItemClick?: (callback: () => void) => void,
        needCache?: boolean
    ) => void;
    className?: string;
}

const CollapseLoginItems: React.FC<CollapseLoginItemsProps> = (props) => {
    const { className, loginItems, onLoginItemClick } = props;
    const [isDrawerVisible, setDrawerVisible] = useState<boolean>(false);

    if (isEmpty(loginItems)) {
        return null;
    }

    const isMobile = isMobileUA();

    const renderCollapsedTrigger = (onClick?: () => void) => {
        return (
            <div className={className} onClick={onClick}>
                <IconFont type="other" />
            </div>
        );
    };

    const renderCollapsedItems = () => {
        return (
            <Menu
                className="fx-collapse-login-items"
                items={map(loginItems, (item) => {
                    const config = getOtherLoginItemConfig(item);
                    // 支持所选登录方式的子产品列表
                    const suites = getAllowSelectedSuites(item);
                    const needSelectSuite = size(suites) > 1;
                    return {
                        icon: config.icon,
                        label: config.text,
                        content: isMobile
                            ? () => {
                                  return (
                                      <div className="login-item">
                                          {config.icon}
                                          <span>{config.text}</span>
                                      </div>
                                  );
                              }
                            : undefined,
                        className: 'collapse-login-item',
                        onClick: () => {
                            if (needSelectSuite) {
                                onLoginItemClick(item, undefined, false);
                            } else {
                                onLoginItemClick(item, config.onClick);
                            }
                        }
                    };
                })}
            />
        );
    };

    if (isMobile) {
        return (
            <>
                {renderCollapsedTrigger(() => {
                    setDrawerVisible(true);
                })}
                <Drawer
                    className="fx-collapse-login-items-drawer"
                    visible={isDrawerVisible}
                    closable={false}
                    autoClose
                    edge={{ height: 'auto' }}
                    onClose={() => setDrawerVisible(false)}
                >
                    {renderCollapsedItems()}
                    <div className="cancel-btn" onClick={() => setDrawerVisible(false)}>
                        {Intl.get('cancel')}
                    </div>
                </Drawer>
            </>
        );
    }

    return (
        <Popover
            placement="top-left"
            trigger="click"
            hasPadding={false}
            arrow={false}
            content={renderCollapsedItems()}
        >
            {renderCollapsedTrigger()}
        </Popover>
    );
};

export default CollapseLoginItems;
